const ExperienceDatas = [
    {id: '0',
    Title:'We Ker - Service Civique',
    Subtitle: 'Service Civique - Lutter contre la fracture numérique - We Ker (Mission Locale de Rennes)',
    Content: 'Création d\'une charte éditoriale pour les Réseaux Sociaux (Twitter, Facebook, Instagram). Réalisation de différents visuels pour le web (InDesign et Illustrator). Mise à jour et publication de contenu sur le WordPress de l\'association.',
    Date:'24/10/2018 au 28/08/2019'},
    {id: '1',
    Title:'Développeur web - Dewan Développement',
    Subtitle: 'Création et développement de site web pour la Start-up Dewan Développement',
    Content: 'Création de 2 sites web pour la Start-Up Dewan Développement. Un premier site Réalisé sur Gatsby en Génération Statique via Netlify. Un Second sur WordPress.Définition des besoins et de la stratégie web de l\'entreprise en lien avec le chargé de communication et de la CEO',
    Date:'15/03/2020 au 15/06/2021'},
    {id: '2',
    Title:'Développeur web - Sterenn&Co',
    Subtitle: 'Intégration web et développement Wordpress pour l\'entreprise Sterenn&Co',
    Content: 'Définition des besoins de contenu, publication, stratégie SEO et création de maquette pour le site institutionnel de l\'entreprise. Intégrations de page et contenu sur le CMS Magento pour le site e-commerce. Création d\'une interface de gestion de commandes entre Magento et l\'ERP Business Centrale. Préparation de pages fixes pour un nouveau site e-commerce',
    Date:'Du 06/09/2020 au 26/08/2022'},
     ];

export default ExperienceDatas;